// extracted by mini-css-extract-plugin
export default {"container":"clear-icon_container__lgcQr","visible":"clear-icon_visible__Pv1aJ"};